import queryString from 'query-string'
import { filterQueryParams, decamelizeKeys } from '@/utils'
import { DocumentAPI } from './types'

export const documentApi: DocumentAPI = ky => {
  return {
    async fetch({ patientId, page }) {
      const params = filterQueryParams({ page })

      return ky(`patient/${patientId}/document/`, {
        method: 'get',
        searchParams: queryString.stringify(params)
      }).json()
    },

    async fetchFile({ patientId, documentId }) {
      return ky(`patient/${patientId}/document/${documentId}/download/`, {
        method: 'get'
      }).blob()
    },

    async fetchOne({ patientId, documentId }) {
      return ky(`patient/${patientId}/document/${documentId}/`, {
        method: 'get'
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/document/`, {
        method: 'post',
        body: JSON.stringify(decamelizeKeys(payload))
      }).json()
    },

    async update({ patientId, documentId, payload }) {
      return await ky(`patient/${patientId}/document/${documentId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async patch({ patientId, documentId, payload }) {
      return await ky(`patient/${patientId}/document/${documentId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async delete({ patientId, documentId }) {
      await ky(`patient/${patientId}/document/${documentId}/`, {
        method: 'delete'
      })
    }
  }
}
